import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Divider, Flex, Text, Button, Card } from 'src/components';
import { colors } from "src/theme";
import { i18n, ProductTypeCodeEnum, setPaymentType, useAppDispatch } from "src/common";
import { AppRoutes } from "src/pages/app";
import styled from "@emotion/styled";
import { sendGeneralTransferDetailsToEmail } from 'src/common/api/apollo/supplementary';

const FlexStyle = styled(Flex)({
  padding: '0 12px',
});

interface GeneralTranferPaymentInfoCardProps {
  type?: string;
  offerId: string;
}

export const GeneralTranferPaymentInfoCard = ({ type = 'oneTime', offerId }: GeneralTranferPaymentInfoCardProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [sendGeneralTransferDetailsToEmailMutation] = useMutation(sendGeneralTransferDetailsToEmail);

  useEffect(() => {
    dispatch(setPaymentType(type));
  }, [type]);

  const handlePay = () => {
    if (type === 'oneTime') {
      sendGeneralTransferDetailsToEmailMutation({
        variables: { id: offerId, input: { type: ProductTypeCodeEnum.DOPUNSKO, installments: 1 } }
      });
      navigate(`${AppRoutes.CHECKOUT_PAYMENT_SENT.fullPath}/${offerId}`)
    }
    else {
      sendGeneralTransferDetailsToEmailMutation({
        variables: { id: offerId, input: { type: ProductTypeCodeEnum.DOPUNSKO, installments: 12 } }
      });
      navigate(`${AppRoutes.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath}/${offerId}`)
    }
  }

  return (
    <Flex vertical gap={16}>
      <Card background={colors.success2} radius={8} padding={'4px 8px'}>
        <Flex gap={8} align='flex-start' vertical>
          <Text type='base' bold color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.important')}</Text>
          <Text type='small' color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.text')} <b>{i18n.t('components.cards.generalTranferPaymentInfoCard.text2')}</b> {i18n.t('components.cards.generalTranferPaymentInfoCard.text3')}</Text>
        </Flex>
      </Card>
      <Divider dashed color={colors.border3} />
      <FlexStyle gap={12} vertical>
        <Text type='base' bold color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.steps')}</Text>
        <Flex gap={8} align='flex-start' vertical>
          {[
            i18n.t('components.cards.generalTranferPaymentInfoCard.step1'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step2'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step3'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step4')
          ].map((step, index) => (
            <Flex key={index} gap={8} align="flex-start">
              <Text type='small' color={colors.text1} style={{ minWidth: '20px' }}>
                {index + 1}.
              </Text>
              <Text type='small' color={colors.text1}>
                {step}
              </Text>
            </Flex>
          ))}
        </Flex>
        {type === 'installments' && <Text type='small' color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.text4')}</Text>}
      </FlexStyle>
      <Button btnType='primary' text={i18n.t('components.cards.generalTranferPaymentInfoCard.button')} onClick={handlePay} />
    </Flex>
  )
}
